var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React from 'react';
import { Card } from 'antd';
import classNames from 'classnames';
import './index.less';
const renderTotal = (total) => {
    let totalDom;
    switch (typeof total) {
        case 'undefined':
            totalDom = null;
            break;
        case 'function':
            totalDom = React.createElement("div", { className: "total" }, total());
            break;
        default:
            totalDom = React.createElement("div", { className: "total" }, total);
    }
    return totalDom;
};
export default class ChartCard extends React.Component {
    constructor() {
        super(...arguments);
        this.renderConnet = () => {
            const { contentHeight, title, avatar, action, total, footer, children, loading } = this.props;
            if (loading) {
                return false;
            }
            return (React.createElement("div", { className: "chartCard" },
                React.createElement("div", { className: classNames("chartTop", {
                        "chartTopMargin": !children && !footer,
                    }) },
                    React.createElement("div", { className: "avatar" }, avatar),
                    React.createElement("div", { className: "metaWrap" },
                        React.createElement("div", { className: "meta" },
                            React.createElement("span", { className: "title" }, title),
                            React.createElement("span", { className: "action" }, action)),
                        renderTotal(total))),
                children && (React.createElement("div", { className: "content", style: { height: contentHeight || 'auto' } },
                    React.createElement("div", { className: contentHeight ? "contentFixed" : undefined }, children))),
                footer && (React.createElement("div", { className: classNames("footer", {
                        "footerMargin": !children,
                    }) }, footer))));
        };
    }
    render() {
        const _a = this.props, { loading = false, contentHeight, title, avatar, action, total, footer, children } = _a, rest = __rest(_a, ["loading", "contentHeight", "title", "avatar", "action", "total", "footer", "children"]);
        return (React.createElement(Card, Object.assign({ loading: loading, bodyStyle: { padding: '20px 24px 8px 24px' } }, rest), this.renderConnet()));
    }
}
